'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Popover2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Popover.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Popover.js
 ** module chunks = 0
 **/